import Vue from 'vue'
import Router from 'vue-router'
import EPub from '@/components/EPub'
import App from '@/components/App'
import Pdf from '@/components/Pdf'
import User from '@/components/User'
import Signup from '@/components/Signup'
import NotLogged from '@/components/NotLogged'
import Notlogin from '@/components/Notlogin'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import ForgotPassword from '@/components/ForgotPassword'
import ResetPassword from '@/components/ResetPassword'
import Google from '@/components/Google'
import SocialSignup from '@/components/SocialSignup'
import Library from '@/components/Library'
import Gift from '@/components/Gift'
import Profile from '@/components/Profile'
import Shelf from '@/components/Shelf'
import Category from '@/components/Category'
import Publish from '@/components/Publish'
import Wallet from '@/components/Wallet'
import Settings from '@/components/Settings'
import Publications from '@/components/Publications'
import EditBooks from '@/components/EditBooks'
import Books from '@/components/Books'
import Err from '@/components/Err'
import VueMeta from 'vue-meta'

Vue.use(Router)
Vue.use(VueMeta)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'App',
      component: App
    },
    {
      path: '/epub/:id',
      name: 'epub-reader-page',
      component: EPub
    },
    {
      path: '/pdf/:id',
      name: 'pdf-reader-page',
      component: Pdf
    },
    {
      path: '/author/:id',
      name: 'User',
      component: User
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/notlogged',
      name: 'NotLogged',
      component: NotLogged
    },
    {
      path: '/notloggedin',
      name: 'Notlogin',
      component: Notlogin
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/googlesignup',
      name: 'Google',
      component: Google
    },

    {
      path: '/socialsignup',
      name: 'SocialSignup',
      component: SocialSignup
    },

    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/forgotpassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/shelf',
      name: 'Shelf',
      component: Shelf
    },
    {
      path: '/category/:id',
      name: 'Category',
      component: Category
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/library',
      name: 'Library',
      component: Library
    },
    {
      path: '/gift',
      name: 'Gift',
      component: Gift
    },

    {
      path: '/wallet',
      name: 'Wallet',
      component: Wallet
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/publish',
      name: 'Publish',
      component: Publish
    },
    {
      path: '/publications',
      name: 'Publications',
      component: Publications
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/edit-books/:id',
      name: 'edit-books-page',
      component: EditBooks
    },
    {
      path: '/books/:id',
      name: 'Books',
      component: Books
    },
    {
      path: '/404/:id',
      name: 'Err',
      component: Err
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js